/* eslint-disable max-len */
import { ComponentPropsWithoutRef, memo } from 'react';

function SpinnerIcon(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
      {...props}
    >
      <circle
        cx="50"
        cy="50"
        fill="none"
        stroke="#ffffff"
        strokeWidth="7"
        r="33"
        strokeDasharray="155.50883635269477 53.83627878423159"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          repeatCount="indefinite"
          dur="0.9615384615384615s"
          values="0 50 50;360 50 50"
          keyTimes="0;1"
        />
      </circle>
    </svg>
  );
}

export default memo(SpinnerIcon);
